import React, { useEffect, useState } from "react";
import "./more-about-authors.m.css";
import AuthorImage from "../AuthorImage";
import { Link } from "@quintype/components";
import { handleAuthorInteraction } from "../../../../ga-utils";
import { ABOUT_THE_AUTHOR_TITLE } from "../../../../constants";
import { get } from "lodash";
import { getAuthorById } from "../../../../../api/utils";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";

const MoreAboutAuthors = ({ authors = [], story = {}, config, pageType = "story-page" }) => {
  const [authorRoles, setAuthorRoles] = useState([]);
  const ChartCount = isMobile ? 120 : 260;

  if (authors.length === 0) {
    return null;
  }

  const qtState = useSelector((state) => state);
  const isWebView = get(qtState, ["qt", "config", "isWebView"]) === true;
  const isWebViewQuery = isWebView ? "?webview=true" : "";
  const isAuthorImageRequired = get(story, ["metadata", "story-attributes", "authorimagerequired", "0"], false);

  useEffect(() => {
    const fetchAuthorRoles = async () => {
      if (authors.length === 0 || !isAuthorImageRequired || isAuthorImageRequired === "false") return;

      try {
        const roles = await Promise.all(
          authors.map(async (author) => {
            const authorInfo = await getAuthorById(author.id);
            return get(authorInfo, ["metadata", "meta-title"], "");
          })
        );
        setAuthorRoles(roles);
      } catch (error) {
        console.error("Error fetching author information:", error);
      }
    };

    fetchAuthorRoles();
  }, [authors, isAuthorImageRequired]);

  const newAuthors = authors.filter((author) => author.bio && author.bio.trim() !== "");

  return (
    <>
      {newAuthors.length > 0 && isAuthorImageRequired && isAuthorImageRequired !== "false" && (
        <div styleName="wrapper">
          <div styleName="title">{ABOUT_THE_AUTHOR_TITLE}</div>
          {newAuthors.map((author, index) => {
            const authorUrl = `/author/${author.slug}`;
            if (!author?.bio) return null;

            const isReadmoreVisible = author.bio.length > 120;
            const authorbio = isReadmoreVisible ? author.bio.substring(0, ChartCount) + "..." : author.bio;

            return (
              <div styleName="author-info" key={author.id}>
                <div styleName="image-name-wrapper">
                  <AuthorImage author={author} isClickable={true} />
                  <div styleName="name-role-wrapper">
                    <Link
                      href={authorUrl}
                      disableAjaxLinks={true}
                      onTouchStart={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
                      onMouseDown={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
                    >
                      <div styleName="author-name">{author.name}</div>
                    </Link>
                    {authorRoles[index] && <div styleName="author-role">{authorRoles[index]}</div>}
                  </div>
                </div>
                <div styleName="author-bio">
                  {authorbio}
                  {isReadmoreVisible && <Link href={authorUrl + isWebViewQuery}>Read more</Link>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default MoreAboutAuthors;
